module.exports = __webpack_public_path__ + "img/CM-SS-25-Mazda-Modern.871d55a2.jpg";